module.exports = __webpack_public_path__ + "static/media/th-TH.7fe7a7ea.md";